// extracted by mini-css-extract-plugin
module.exports = {"sections":"Sections_sections__Xe1CV","section":"Sections_section__0Ur7r","links":"Sections_links__gz7ZK","skeleton":"Sections_skeleton___W0F8","divider":"Sections_divider__WSpDc"};